import { RegionWithImages } from "../Types/regionTypes";
import { regionsApi } from "./regionsApi";
import { TagTypes } from "../../../Api/Types/tagTypes";

export const extendedRegionsApi = regionsApi.injectEndpoints({
  endpoints: (builder) => ({
    getRegionWithImages: builder.query<RegionWithImages, number>({
      query: (id) => `/regions/${id}/with-images`,
      providesTags: (result, error, id) => [{ type: TagTypes.RegionImages, id }],
    }),

    uploadRegionImages: builder.mutation<
      { imageIds: string[]; count: number },
      { regionId: number; files: File[] }
    >({
      query: ({ regionId, files }) => {
        const formData = new FormData();
        files.forEach((file) => formData.append('Files', file));
        formData.append('Category', 'Region');
        formData.append('EntityId', regionId.toString());

        return {
          url: '/images/upload-multiple',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (result, error, { regionId }) => [
        { type: TagTypes.RegionImages, id: regionId },
      ],
    }),

    deleteRegionImage: builder.mutation<void, { imageId: string; regionId: number }>({
      query: ({ imageId }) => ({
        url: `/images/${imageId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { regionId }) => [
        { type: TagTypes.RegionImages, id: regionId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetRegionWithImagesQuery,
  useUploadRegionImagesMutation,
  useDeleteRegionImageMutation,
} = extendedRegionsApi;
